document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll('.cartCheckoutBtnWrapper .checkoutBtngrid input[type="submit"]')
  .forEach(function(button) {

    // Remove disabled attribute if present
    button.removeAttribute('disabled');

    button.addEventListener('click', function () {
      var waiting_text = this.getAttribute('data-wait');
      if (waiting_text && waiting_text !== 'undefined') {
        this.value = waiting_text;
      }else {
        this.value = 'Please wait...';
      }
      window.location.href = '/checkout';
    });
  });


  const getCartCurrency = (cart) => {
    const host = (window.location && window.location.hostname || '').toLowerCase();
    if (host.indexOf('uk.') === 0 || host.indexOf('uk.cushiehome.com') !== -1) return 'GBP';
    if (host.indexOf('ca.') === 0 || host.indexOf('ca.cushiehome.com') !== -1) return 'CAD';
    return (
      (cart && cart.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.isoCode) ||
      (window.theme && window.theme.currencyCode) ||
      'USD'
    );
  };

  const formatMoney = (cents, cart) => {
    const amount = (Number(cents) || 0) / 100;
    const currency = getCartCurrency(cart);
    const formatted = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (currency === 'GBP') return '£' + formatted;
    return '$' + formatted;
  };


  const updateCartInstallmentText = (cart) => {
    const installmentEls = document.querySelectorAll('.brk_price');
    if (!installmentEls.length || !cart) return;
    const monthlyCents = (Number(cart.total_price) || 0) / 12;
    const installmentText = formatMoney(monthlyCents, cart) + '/Month';
    installmentEls.forEach((el) => { el.textContent = installmentText; });
  };

  // Cart page hotfix: the cached discount-box snippet may still rewrite totals with a hardcoded "$".
  // Keep the visible cart page totals normalized to the active market currency after all inline scripts run.
  const normalizeCartPageCurrencyTotals = async () => {
    const subtotalEl = document.querySelector('#cart-subtotal');
    const totalEl = document.querySelector('#cart-page-total');
    if (!subtotalEl && !totalEl) return;
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await response.json();
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price || cart.original_total_price || 0, cart);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0, cart);
    } catch (error) {
      console.warn('Unable to normalize cart page currency totals', error);
    }
  };

  normalizeCartPageCurrencyTotals();
  setTimeout(normalizeCartPageCurrencyTotals, 250);
  setTimeout(normalizeCartPageCurrencyTotals, 1000);
  setTimeout(normalizeCartPageCurrencyTotals, 2500);
  window.addEventListener('load', normalizeCartPageCurrencyTotals);

  
  const updateCartTotals = async (cart) => {
    // console.log('Cart object:', cart);

    if (Array.isArray(cart.items)) {
      if (cart.item_count === 0) {
        $('.cart-customize-layout-wrapper .cart-empty-container').show();
        $('.cart-customize-layout-wrapper .form-block.w-form').hide();
        $('#cart-checkout-button').addClass('disabled-checkout');
      } else {
        $('.cart-customize-layout-wrapper .cart-empty-container').hide();
        $('.cart-customize-layout-wrapper .form-block.w-form').show();
        $('#cart-checkout-button').removeClass('disabled-checkout');
      }

      // === Cart Page Elements ===
      const subtotalEl = document.querySelector('#cart-subtotal');
      const totalEl = document.querySelector('#cart-page-total');
      const discountValueEl = document.querySelector('#cart-page-discount-total');
      const saveDiscountEl = document.querySelector('#cart-page-saved-discount');

      // === Drawer Elements ===
      const drawerSubtotalEl = document.querySelector('.cart_sub_total_price');
      const drawerTotalEl = document.querySelector('#price-all-cart');
      const drawerDiscountAdd = document.querySelector('.cart_discount_add');
      const shipping = document.querySelector('.cartShipping');
      const displayedCodes = new Set();

      let discountCouponsArr = ['end of year sale, 10% off','end of year sale, 15% off','end of year sale, 20% off','end of year sale,  20% off','end of year sale, 25% off','end of year sale, 30% off'];

      /* const drawerDiscountCode = document.querySelector('.discount_code');
      const drawerDiscountPrice = document.querySelector('.total_discount_price'); */

      if($('.cart-lines .cartDiscountRow').length > 0){
        $('.cart-lines .cartDiscountRow').remove();
      }

      if (cart.total_discount > 0) {
        
        // === Cart Page Updates ===
        // if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price, cart);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price, cart);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart);
        if (discountValueEl) discountValueEl.textContent = '-' + formatMoney(cart.total_discount, cart);

        const discountPercent = Math.round((cart.total_discount * 100) / (cart.original_total_price || 1));
        if (saveDiscountEl) saveDiscountEl.textContent = `Save ${discountPercent}%`;

        // === Drawer Updates ===
        if (drawerSubtotalEl) drawerSubtotalEl.textContent = formatMoney(cart.items_subtotal_price, cart);
        if (drawerTotalEl) drawerTotalEl.textContent = formatMoney(cart.total_price, cart);

        /* if (drawerDiscountPrice) drawerDiscountPrice.textContent = '-' + formatMoney(cart.total_discount, cart);

        if (drawerDiscountCode && cart.cart_level_discount_applications.length > 0) {
          drawerDiscountCode.textContent = cart.cart_level_discount_applications[0].title;
          drawerDiscountCode.classList.remove('hide');
          if (drawerDiscountAdd) drawerDiscountAdd.classList.add('hide');
        } */

      }else {

        // === Manual Recalculation ===
        let cartSubtotal = 0;
        let cartTotal = 0;

        for (const item of cart.items) {
          const itemPrice = item.price;
          cartSubtotal += itemPrice * item.quantity;
          cartTotal += itemPrice * item.quantity;
        }

        const cartSavings = cartSubtotal - cartTotal;
        const discountPercent = Math.round((cartSavings * 100) / (cartSubtotal || 1));

        // === Cart Page Updates ===
        if (subtotalEl) subtotalEl.textContent = formatMoney(cartSubtotal, cart);
        if (discountValueEl) discountValueEl.textContent = '-' + formatMoney(cartSavings, cart);
        if (saveDiscountEl) saveDiscountEl.textContent = `Save ${discountPercent}%`;
        if (totalEl) totalEl.textContent = formatMoney(cartTotal, cart);

        // === Drawer Updates ===
        if (drawerSubtotalEl) drawerSubtotalEl.textContent = formatMoney(cartSubtotal, cart);
        if (drawerTotalEl) drawerTotalEl.textContent = formatMoney(cartTotal, cart);

        /* if (drawerDiscountPrice) drawerDiscountPrice.textContent = '-' + formatMoney(cartSavings, cart);

         if (drawerDiscountCode) {
          drawerDiscountCode.textContent = '';
          drawerDiscountCode.classList.add('hide');
        } 

        if (drawerDiscountAdd) {
          drawerDiscountAdd.classList.remove('hide');
        } */

      }

      updateCartInstallmentText(cart);

      if (cart.cart_level_discount_applications?.length) {
        for (let allocation of cart.cart_level_discount_applications) {
          const discount_code = allocation.title?.toLowerCase();
          let amount = allocation.total_allocated_amount;

          if(amount){
            amount = formatMoney(amount, cart);
          }

          if (!discount_code) continue;

          // Then insert into DOM only if not already displayed
          if (!displayedCodes.has(discount_code)) {
            displayedCodes.add(discount_code);

            const cartlevelDiscount = document.createElement('div');
            cartlevelDiscount.className = 'cart-line cartDiscountRow';

            let code_to_match = discount_code.replace(/['"“”‘’]/g, '').trim();

            if (discountCouponsArr.includes(code_to_match)){
              cartlevelDiscount.innerHTML = `
                <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}</span>
                <div class="appliedDiscountAmount semi-text">-${amount}</div>
              `;
            }else{
               cartlevelDiscount.innerHTML = `
                <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}<span class="removeDiscountCode">x</span></span>
                <div class="appliedDiscountAmount semi-text">-${amount}</div>
              `;
            }
            
            shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
          }
        }
      }

      // --- Insert item-level discounts ---
      if (cart.items?.length) {
        for (let item of cart.items) {
          if (item.line_level_discount_allocations?.length) {
            for (let allocation of item.line_level_discount_allocations) {
              const discount_code = allocation.discount_application?.title?.toLowerCase();
              let amount = allocation.discount_application?.total_allocated_amount;

              if(amount){
                amount = formatMoney(amount, cart);
              }

              if (discount_code && !displayedCodes.has(discount_code)) {
                displayedCodes.add(discount_code);
                const cartlevelDiscount = document.createElement('div');
                cartlevelDiscount.className = 'cart-line cartDiscountRow';

                let code_to_match = discount_code.replace(/['"“”‘’]/g, '').trim();

                if (discountCouponsArr.includes(code_to_match)){
                  cartlevelDiscount.innerHTML = `
                    <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}</span>
                    <div class="appliedDiscountAmount semi-text">-${amount}</div>
                  `;
                }else{
                  cartlevelDiscount.innerHTML = `
                    <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}<span class="removeDiscountCode">x</span></span>
                    <div class="appliedDiscountAmount semi-text">-${amount}</div>
                  `;
                 
                }
               
                shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
              }
            }
          }
        }
      }

    } else {
      console.log('cart.items is not an array', cart.items);
    }
  };
  

  const updateCartLineItems = async (cart) => {
    for (const item of cart.items) {
      const price = item.price;
      const quantity = item.quantity;
      const lineTotal = formatMoney(price * quantity, cart);
      const itemKey = item.key;
      const variantId = item.variant_id;

      let check_sale = false;
      let sale_percentage = 0;
      let saleTotal = (price * quantity);
      let saleDiscounted = 0;

      // console.log('test');

      // === Cart Page ===
      const cartItemEl = document.querySelector(`.cart-item-3[data-id="${variantId}"]`);
      if (cartItemEl) {
        const priceEls = cartItemEl.querySelectorAll('.final-line-price');
        const comppriceEls = cartItemEl.querySelectorAll('.cart_compare_price');
        const qtyInput = cartItemEl.querySelector('.cart-qty-input');
        
        if (qtyInput) qtyInput.value = quantity;

        const check_sale = cartItemEl.getAttribute('data-sale');
        const sale_percentage = parseFloat(cartItemEl.getAttribute('data-sale-percent')) || 0;

        // Convert "true"/"false" string to boolean
        const isSaleActive = check_sale === 'true' || check_sale === true;

        if (isSaleActive && sale_percentage > 0) {
          const saleDiscounted = saleTotal - (saleTotal * sale_percentage / 100);
          
          priceEls.forEach((priceEl) => {
            if (priceEl) priceEl.textContent = formatMoney(saleDiscounted, cart);
          });

          comppriceEls.forEach((compEl) => {
            if (compEl) compEl.textContent = lineTotal;
          });

        }else{
          priceEls.forEach((priceEl) => {
            if (priceEl) priceEl.textContent = lineTotal;
          });
          comppriceEls.forEach((compEl) => {
            if (compEl) {
              compEl.textContent = '';
              compEl.style.display = 'none';
            }
          });
        }
      }

      // === Drawer Cart ===
      const drawerItemEl = document.querySelector(`.cart-item-2[data-id="${variantId}"]`);
      if (drawerItemEl) {
          const priceEl = drawerItemEl.querySelector('.cart_main_price');
          const crossPriceEl = drawerItemEl.querySelector('.cart_cross_price');
          const savingEl = drawerItemEl.querySelector('.cart_saving_prd');
          const qtyInput = drawerItemEl.querySelector(`[id^="mini-cart-quantity"]`);
          const drawerSaleActive = drawerItemEl.getAttribute('data-sale') === 'true' || drawerItemEl.getAttribute('data-sale') === true;
          const drawerSalePercent = parseFloat(drawerItemEl.getAttribute('data-sale-percent')) || 0;

          if (drawerSaleActive && drawerSalePercent > 0) {
            const saleDiscounted = saleTotal - (saleTotal * drawerSalePercent / 100);
            if (priceEl) priceEl.textContent = formatMoney(saleDiscounted, cart);
            if (crossPriceEl) {
              crossPriceEl.textContent = lineTotal;
              crossPriceEl.style.display = '';
            }
            if (savingEl) {
              savingEl.textContent = `Save ${drawerSalePercent}%`;
              savingEl.style.display = '';
            }
          } else {
            const normalLinePrice = typeof item.final_line_price === 'number' ? item.final_line_price : saleTotal;
            if (priceEl) priceEl.textContent = formatMoney(normalLinePrice, cart);
            if (crossPriceEl) crossPriceEl.style.display = 'none';
            if (savingEl) savingEl.style.display = 'none';
          }

          if (qtyInput) qtyInput.value = quantity;
      }
    }
  };


    const updateCartCount = async (cart) => {
        const count = cart.item_count;
        let count_updated = '';

        if (count > 0) {
            count_updated = (count < 10 ? '0' + count : count) + (count === 1 ? ' item' : ' items');
            $('#cart-checkout-button').removeClass('disabled-checkout');
        } else {
            count_updated = '0 items'; // or you could use 'No items' if preferred
            $('#cart-checkout-button').addClass('disabled-checkout');
        }

        if (count_updated) {
            $('.cart-new-template-2025 .counter .counter-text').text(count_updated);
        }

        $('#mainHeader .header_grid #mini-cart-items-all').text(count);
        $('.cart-header .cart_total_items').text('( '+count+' items )');
    };


    let cartUpdateDebounceTimer;

    document.addEventListener('click', function (e) {
      
      const btn = e.target.closest('.cart-plus, .cart-minus');
      if (!btn) return;
    
      const container = btn.closest('.cart-item-3') || btn.closest('.cart-item-2');
      if (!container) return;

      console.log('container console', container);
    
      const input = container.querySelector('.cart-qty-input') || container.querySelector('[id^="mini-cart-quantity"]');
      if (!input) return;
    
      let qty = parseInt(input.value, 10);
      const key = input.name || input.id;
      if (!key) return;
    
      const isPlus = btn.classList.contains('cart-plus') || btn.innerText.trim() === '+';
      const isMinus = btn.classList.contains('cart-minus') || btn.innerText.trim() === '-';
    
      qty = isPlus ? qty + 1 : Math.max(1, qty - 1);
      input.value = qty;
    
      // Debounce the cart update
      clearTimeout(cartUpdateDebounceTimer);
      
      cartUpdateDebounceTimer = setTimeout(async () => {
        
        const cartFooters = document.querySelectorAll('.cart-footer-2');
        const cartLoaders = document.querySelectorAll('.cart-total-loader');
        // const drawerWrappers = document.querySelectorAll('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper');
        
        cartFooters.forEach(footer => footer.classList.add('show-loader'));
        cartLoaders.forEach(loader => loader.classList.remove('hide'));

      //  $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper').addClass('show-loader');
      // $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper .cart-total-loader').removeClass('hide');
        
        try {
          // Update cart with new quantity
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              updates: {
                [key]: qty
              }
            }),
          })
    
          // Fetch the fresh cart state
          const refreshedCart = await fetch('/cart.js', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            cache: 'no-store'
          }).then(res => res.json()); 


          // Update the DOM
          await updateCartLineItems(refreshedCart);
          await updateCartTotals(refreshedCart);
          await updateCartCount(refreshedCart);
    
        }catch (error) {
          console.error('Error updating cart:', error);
        }finally {
          cartFooters.forEach(footer => footer.classList.remove('show-loader'));
          cartLoaders.forEach(loader => loader.classList.add('hide'));
        }
      }, 400); // debounce delay (ms)
    });


    // Quantity input change
    $(document).on('change', '.quantity-block input.cart-qty-input', function() {
        const new_qty = parseInt($(this).val());
        const key = $(this).attr('id');

        let cartFooter = document.querySelectorAll('.cart-customize-layout-wrapper .cart-items .cart-footer-2');
        cartFooter.forEach(function(footer) {
            footer.classList.add('show-loader');
        });

        let cartLoader = document.querySelectorAll('.cart-customize-layout-wrapper .cart-items .cart-footer-2 .cart-total-loader');
        cartLoader.forEach(function(loader) {
            loader.classList.remove('hide');
        });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [key]: new_qty
            }
          })
        })
        .then(res => res.json())
        .then(cart => {
          updateCartTotals(cart);
          updateCartLineItems(cart);
          updateCartCount(cart);
        
          cartFooter.forEach(function(footer) {
            footer.classList.remove('show-loader');
          });
        
          cartLoader.forEach(function(loader) {
            loader.classList.add('hide');
          });
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        
          cartFooter.forEach(function(footer) {
            footer.classList.remove('show-loader');
          });
        
          cartLoader.forEach(function(loader) {
            loader.classList.add('hide');
          });
        });

    });

    // Remove cart item
    document.addEventListener('click', function(e) {
      if (e.target.closest('.cart-remove-btn')) {
        e.preventDefault();
    
        const button = e.target.closest('.cart-remove-btn');
        const container = button.closest('.cart-item-3');
        const variantId = parseInt(button.closest('[data-variant-id]').dataset.variantId);
        const container1 = $('.cart-item-2[data-id="'+variantId+'"]');
    
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const item = cart.items.find(i => i.variant_id === variantId);
            if (!item) return;
    
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {
                  [item.key]: 0 // This will remove the item
                }
              })
            });
          })
          .then(res => res.json())
          .then(updatedCart => {
            
            if(updatedCart.item_count == 0){
              $('.sticky-checkout-button-wrapper').hide();
            }else{
              $('.sticky-checkout-button-wrapper').show();
            }

            if (container) container.remove();
            if (container1) container1.remove();
            updateCartTotals(updatedCart);
            updateCartLineItems(updatedCart);
            updateCartCount(updatedCart);
          })
          .catch(err => console.error('Error removing item:', err));
      }
    });


    const inputs = document.querySelectorAll(".cart-customize-layout-wrapper .cart_items_ .quantity-block .quantity");

    inputs.forEach(input => {
      // Prevent invalid keys like e, E, +, -, and .
      input.addEventListener("keydown", function (e) {
        const invalidKeys = ['e', 'E', '+', '-', '.'];
        if (invalidKeys.includes(e.key)) {
          e.preventDefault();
        }
      });
    
      // Sanitize pasted input or non-numeric typing
      input.addEventListener("input", function () {
        let cleaned = this.value.replace(/[^0-9]/g, '');
    
        // Prevent value lower than min or greater than max
        const min = parseInt(this.min || 1);
        const max = parseInt(this.max || 999999);
    
        if (cleaned !== '') {
          let numericValue = parseInt(cleaned);
          if (numericValue < min) numericValue = min;
          if (numericValue > max) numericValue = max;
          this.value = numericValue;
        } else {
          this.value = min; // or '' if you want to allow empty temporarily
        }
      });
    });



    document.addEventListener('cart:updated', function(e) {
      console.log('Cart updated!', e.detail); // e.detail = cart object
    });

  
});